import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { userGuard } from '@core/guards';
import { AppRouterHelper } from '@core/helpers';
import { AccountClearCookiesComponent } from '@shared/pages/account-clear-cookies/account-clear-cookies.component';
import { ErrorPageComponent } from '@shared/pages/error-page/error-page.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'checkmate',
        pathMatch: 'full',
    },
    {
        path: 'checkmate',
        canActivate: [AuthGuard],
        loadChildren: () => import('./core/routes/ckm.routes').then(m => m.ckmRoutes),
        data: {
            breadcrumb: 'CheckMate',
        },
    },
    {
        path: 'sequencing',
        canActivate: [AuthGuard],
        loadChildren: () => import('./core/routes/sequencing.routes').then(m => m.seqRoutes),
        data: {
            breadcrumb: 'Sequencing',
        },
    },
    {
        path: 'strains',
        canActivate: [AuthGuard],
        loadChildren: () => import('./core/routes/strains.routes').then(m => m.strainRoutes),
        data: {
            breadcrumb: 'Strains',
        },
    },
    {
        path: 'assays',
        canActivate: [AuthGuard],
        loadChildren: () => import('./core/routes/aim.routes').then(m => m.aimRoutes),
        data: {
            breadcrumb: 'Assays',
        },
    },
    {
        path: 'probes',
        canActivate: [AuthGuard],
        loadChildren: () => import('./core/routes/probes.routes').then(m => m.probesRoutes),
        data: {
            breadcrumb: 'Probes',
        },
    },
    // {
    //     path: 'accounts',
    //     canActivate: [AuthGuard],
    //     loadChildren: () => import('./core/routes/accounts.routes').then(m => m.accountRoutes),
    //     data: {
    //         breadcrumb: 'Accounts',
    //     },
    // },
    {
        path: 'dashboard',
        redirectTo: 'checkmate',
    },
    {
        path: 'error',
        canActivate: [AuthGuard, userGuard],
        component: ErrorPageComponent,
        data: {
            breadcrumb: null,
        },
    },
    {
        path: 'Account/ClearCookies',
        component: AccountClearCookiesComponent,
    },

    ...AppRouterHelper.getLegacyUrls(),

    {
        path: '**',
        redirectTo: 'checkmate',
        pathMatch: 'full',
    },
];
